import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { DatePipe } from "@angular/common";
import { ContentDispatcherComponent } from "../content/dispatcher/content-dispatcher/content-dispatcher.component";

/**
 * Renders a single user message as a right-aligned Material chat bubble.
 * Flattens multipart content arrays (text parts) to a plain string for display.
 * Uploaded files are shown like any other evidence: the dispatcher renders the blocks
 * the stream store holds for this message id.
 */
@Component({
  selector: "lib-chat-user-message",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, ContentDispatcherComponent],
  templateUrl: "./chat-user-message.component.html",
  styleUrl: "./chat-user-message.component.scss",
})
export class ChatUserMessageComponent {
  readonly message = input.required<any>();

  /** Message creation time — uses the message's createdAt if available, else render time. */
  protected readonly timestamp = computed<Date>(() => {
    const ts = this.message()?.createdAt;
    return ts ? new Date(ts) : new Date();
  });

  protected readonly textContent = computed<string>(() => {
    const content = this.message()?.content;
    if (typeof content === "string") return content;
    if (Array.isArray(content)) {
      return content
        .filter((p: any) => p?.type === "text")
        .map((p: any) => p.text ?? "")
        .join("");
    }
    return "";
  });
}
